<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <v-text-field
          v-model="journal.issn"
          label="Issn"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6">
        <v-text-field
                :value="$t('publication.status.' + article.publication_status)"
                :label="$t('form.article.publication_status')"
                required
                readonly
                filled
                outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="journal.title"
          :label="$t('form.article.journal')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field
          v-model="journal.editorial.name"
          :label="$t('table.publisher')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          :value="article.accepted_date"
          :label="$t('form.article.accepted_date')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          v-model="article.online_publication_date"
          :label="$t('label.onlinePublicationDate_short')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-text-field
          v-model="article.final_publication_date"
          :label="$t('label.finalPublicationDate_short')"
          required
          readonly
          filled
          outlined
        ></v-text-field>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "DetailArticle",

  props: {
    article: Object
  },

  data() {
    return {
      journal: {
        editorial: ""
      }
    };
  },

  created() {
    this.getJournal();
  },

  methods: {
    getJournal() {
      const path =
        this.$store.state.endpoint + "/journal/" + this.article.journal;
      axios
        .get(path)
        .then(response => {
          this.journal = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style scoped></style>
